export default class OrderingFormModel {
    private _identifiers: any[];
    private _orders: number[];

    constructor(identifiers: any[], orders: number[]) {
        this._identifiers = identifiers;
        this._orders = orders;
    }

    public get identifiers(): any[] {
        return this._identifiers;
    }

    public set identifiers(identifiers: any[]) {
        this._identifiers = identifiers;
    }

    public get orders(): number[] {
        return this._orders;
    }

    public set orders(orders: number[]) {
        this._orders = orders;
    }
}
